import { render, staticRenderFns } from "./instance-tag.component.vue?vue&type=template&id=5d01b31a&scoped=true"
import script from "./instance-tag.component.vue?vue&type=script&lang=ts"
export * from "./instance-tag.component.vue?vue&type=script&lang=ts"
import style0 from "./instance-tag.component.vue?vue&type=style&index=0&id=5d01b31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d01b31a",
  null
  
)

export default component.exports